import { AlertTriangle } from 'lucide-react';

// Port of main.dart's _ConfigErrorApp — shown when VITE_SUPABASE_URL /
// VITE_SUPABASE_ANON_KEY are missing. Runs before i18n is available, so the
// copy is intentionally not localised; it's a developer-facing bootstrap error.
export function ConfigErrorApp({ message }: { message: string }) {
  return (
    <div className="dark flex min-h-screen items-center justify-center bg-bg p-xl">
      <div className="w-full max-w-prose rounded-lg border border-outline-variant bg-surface p-xl">
        <div className="flex items-center gap-md">
          <AlertTriangle className="text-secondary" size={32} />
          <h1 className="text-[22px] font-bold text-on-surface">Configuration missing</h1>
        </div>
        <p className="mt-lg text-on-surface">{message}</p>
        <p className="mt-xl font-bold text-on-surface">Dev start:</p>
        <pre className="mt-sm overflow-x-auto rounded-md bg-surface-low p-md font-mono text-[13px] text-on-surface">
          cp web/.env.example web/.env  # then fill URL + anon key{'\n'}npm --prefix web install{'\n'}npm --prefix web run dev
        </pre>
      </div>
    </div>
  );
}
